import { create } from 'zustand'
import { getSelectableTableId, getTableRowId } from './pages/DataEntryPage/utils/utils'
import { getTimeInMillis } from './utility/datetime'
import _ from 'lodash'
import { saveAs } from 'file-saver'
import { toast } from 'react-toastify'
// Define your custom equality function
export const customEquality = (prev, current) => {
  return JSON.stringify(prev) === JSON.stringify(current)
}

let initialAllValuesState = {}
export const useAllValues = create((set, get) => ({
  allValues: initialAllValuesState,
  getFormUpdatedAt: () => {
    return get().allValues.updatedAt
  },
  getAllValues: () => {
    return get().allValues
  },
  setAllValues: (payload) => {
    set((state) => ({ allValues: { ...state.allValues, ...payload } }))
  },
  setInitialAllValues: (payload) => {
    set({ allValues: payload })
  },

  /* Here fieldIds is array of field ids which needs to be removed from allValues bofore appending new values (otherComputedValue) */
  updateRowValues: (tableKey, rowKey, updatedRowValues, otherComputedValue, fieldIds = []) => {
    set((state) => {
      // logic to remove the keys having id present in fieldIds
      const copy = _.cloneDeep(state.allValues)

      if (fieldIds.length > 0) {
        Object.keys(copy).forEach((key) => {
          if (key.includes('__')) {
            const ftId = key.split('_')[1].split('__')[0]
            if (fieldIds.includes(+ftId)) {
              delete copy[key]
            }
          }
        })
      }

      return {
        allValues: {
          ...copy,
          ...otherComputedValue,
          updatedAt: getTimeInMillis(),
          [tableKey]: {
            ...copy[tableKey],
            [rowKey]: {
              ...updatedRowValues,
              updatedAt: getTimeInMillis(),
            },
          },
        },
      }
    })
  },
  resetAllValues: () => {
    set({ allValues: initialAllValuesState })
  },
}))

let initialFormDataState = []
export const useFormData = create((set) => ({
  formData: initialFormDataState,
  setFormData: (payload) => {
    set((state) => ({ formData: [...payload] }))
  },
  resetFormData: () => {
    set({ formData: initialFormDataState })
  },
}))

let initialReviewValues = {}
export const useReviewValues = create((set) => ({
  reviewValues: initialReviewValues,
  setReviewValues: (payload) => {
    set({ reviewValues: { ...payload } })
  },
  updateReviewDataRow: (tableId, rowId, values) => {
    set((state) => ({
      reviewValues: {
        ...state.reviewValues,
        ...Object.entries(values).reduce((finalValue, [key, value]) => {
          return key == 'updatedAt'
            ? { ...finalValue }
            : { ...finalValue, [`${key}__${rowId}`]: value }
        }, {}),
        [tableId]: {
          ...state.reviewValues[tableId],
          [getTableRowId(rowId)]: { ...values, updatedAt: getTimeInMillis() },
        },
        updatedAt: getTimeInMillis(),
      },
    }))
  },
  resetReviewValues: () => {
    set({ reviewValues: initialReviewValues })
  },
}))

let initialPreviousProcessDataValues = {}
export const usePreviousProcessData = create((set) => ({
  previousProcessData: initialPreviousProcessDataValues,
  setPreviousProcessData: (payload) => {
    set({ previousProcessData: { ...payload } })
  },
  resetPreviousProcessData: () => {
    set({ previousProcessData: initialPreviousProcessDataValues })
  },
}))

let initialPreviousAllReviews = {}
export const usePreviousAllReviewData = create((set) => ({
  previousAllReviews: initialPreviousAllReviews,
  setPreviousAllReviews: (payload) => {
    set({ previousAllReviews: { ...payload } })
  },
  resetPreviousAllReviews: () => {
    set({ previousAllReviews: initialPreviousAllReviews })
  },
}))

let initialCommentValues = {}
export const useCommentValues = create((set) => ({
  commentValues: initialCommentValues,
  setCommentValues: (payload) => {
    set({ commentValues: { ...payload } })
  },
  updateCommentDataRow: (tableId, rowId, values) => {
    set((state) => ({
      commentValues: {
        ...state.commentValues,
        ...Object.entries(values).reduce((finalValue, [key, value]) => {
          return key == 'updatedAt'
            ? { ...finalValue }
            : {
                ...finalValue,
                [`${key}__${rowId}`]: value,
              }
        }, {}),
        [tableId]: {
          ...state.commentValues[tableId],
          [getTableRowId(rowId)]: { ...values, updatedAt: getTimeInMillis() },
        },
        updatedAt: getTimeInMillis(),
      },
    }))
  },
  resetCommentValues: () => {
    set({ commentValues: initialCommentValues })
  },
}))

let initialProcessContext = {}
export const useProcessContext = create((set) => ({
  processContext: initialProcessContext,
  setProcessContext: (payload) => {
    set({ processContext: payload })
  },
  resetProcessContext: () => {
    set({ processContext: initialFormDataState })
  },
}))

let initialSelectedTableData = {}
export const useSelectedTableData = create((set, get) => ({
  selectedTableData: initialSelectedTableData,
  setSelectedData: (payload) => {
    set({ selectedTableData: payload })
  },
  updateSelectedTableRow: (tableId, updatedValue) => {
    set((state) => {
      return {
        selectedTableData: {
          ...state.selectedTableData,
          [getSelectableTableId(tableId)]: updatedValue,
        },
      }
    })
  },
  unSelectRow: (tableId, rowId) => {
    set((state) => {
      return {
        selectedTableData: {
          ...state.selectedTableData,
          [getSelectableTableId(tableId)]: [
            ...state.selectedTableData[getSelectableTableId(tableId)].filter((it) => it != rowId),
          ],
        },
      }
    })
  },
  selectRow: (tableId, rowId) => {
    set((state) => {
      return {
        selectedTableData: {
          ...state.selectedTableData,
          [getSelectableTableId(tableId)]: [
            ...state.selectedTableData[getSelectableTableId(tableId)],
            rowId,
          ],
        },
      }
    })
  },
  resetSelectedData: () => {
    set({ selectedTableData: initialSelectedTableData })
  },
  getTableSelectedRow: (tableId) => {
    return get().selectedTableData[getSelectableTableId(tableId)]
  },
}))

let initialFieldValidationError = {}
export const useFieldValidationError = create((set) => ({
  fieldValidationError: initialFieldValidationError,
  setFieldValidationError: (payload) => {
    set({ fieldValidationError: { ...payload } })
  },
  resetFieldValidationError: () => {
    set({ fieldValidationError: initialFieldValidationError })
  },
}))

let initialComputedData = {}
export const useComputedData = create((set) => ({
  computedData: initialComputedData,
  setComputedData: (payload) => {
    set({ computedData: { ...payload } })
  },
  resetComputedData: () => {
    set({ computedData: initialComputedData })
  },
}))

// It stores each and every keys for which validation needs to be skipped
let initialNoValidationValues = []
export const useNoValidationValues = create((set, get) => ({
  noValidationValues: initialNoValidationValues,
  setNoValidationValues: (payload) => {
    set((state) => ({
      noValidationValues: [...state.noValidationValues, payload],
    }))
  },
  removeFromNoValidationValues: (payload) => {
    set((state) => ({
      noValidationValues: state.noValidationValues.filter((it) => it != payload),
    }))
  },
  getNoValidationValues: () => {
    return get().noValidationValues
  },
  resetNoValidationValues: () => {
    set({ noValidationValues: initialNoValidationValues })
  },
}))

let initialPageDetails = {}
export const usePageDetails = create((set) => ({
  pageDetails: initialPageDetails,
  setPageDetails: (payload) => {
    set({ pageDetails: { ...payload } })
  },
  resetPageDetails: () => {
    set({ pageDetails: initialPageDetails })
  },
}))

let initialTableStructure = {}
export const useTableStructure = create((set) => ({
  tableStructure: initialTableStructure,
  setTableStructure: (payload) => {
    set((state) => ({
      tableStructure: { ...state.tableStructure, ...payload },
    }))
  },
}))

let initialTableSequenceAndHeaders = {}
export const useTableSequenceAndHeaders = create((set) => ({
  tableSequenceAndHeaders: initialTableSequenceAndHeaders,
  setTableSequenceAndHeaders: (payload) => {
    set((state) => ({
      tableSequenceAndHeaders: payload,
    }))
  },
  resetTableSequenceAndHeaders: () => {
    set({ tableSequenceAndHeaders: initialTableSequenceAndHeaders })
  },
}))

let initialFieldCurrencyMap = {}
export const useFieldCurrencyMap = create((set) => ({
  fieldCurrencyMap: initialFieldCurrencyMap,
  setFieldCurrencyMap: (payload) => {
    set((state) => ({
      fieldCurrencyMap: { ...state.fieldCurrencyMap, ...payload },
    }))
  },
  setInitialFieldCurrencyMap: (payload) => {
    set({
      fieldCurrencyMap: payload,
    })
  },
  resetFieldCurrencyMap: () => {
    set({ fieldCurrencyMap: initialFieldCurrencyMap })
  },
}))

let initialImportedFieldCurrencyMap = []
export const useImportedFieldCurrencyMap = create((set) => ({
  importedFieldCurrencyMap: initialImportedFieldCurrencyMap,
  setImportedFieldCurrencyMap: (payload = []) => {
    set((state) => ({
      importedFieldCurrencyMap: payload,
    }))
  },
}))

export const useStageDownloadStore = create((set, get) => ({
  downloads: {}, // keyed by stageId

  startDownload: ({ stageId, payload, NODE_BASE_URL, userToken }) => {
    const { downloads } = get()

    // already downloading this stage — ignore duplicate click
    if (downloads[stageId]?.isDownloading) return

    const worker = new Worker(new URL('./workers/zipWorker', import.meta.url), {
      type: 'module',
    })

    set({
      downloads: {
        ...downloads,
        [stageId]: {
          isDownloading: true,
          progress: { pct: 0, meta: { loaded: 0, total: 0 } },
          worker,
        },
      },
    })

    worker.postMessage({ payload, NODE_BASE_URL, userToken, concurrency: 3 })

    worker.onmessage = (e) => {
      const current = get().downloads[stageId]
      if (!current) return

      if (e.data.type === 'progress') {
        set({
          downloads: {
            ...get().downloads,
            [stageId]: {
              ...current,
              progress: {
                pct: e.data.pct ?? 0,
                meta: e.data.meta || { loaded: 0, total: 0 },
              },
            },
          },
        })
      }

      if (e.data.type === 'done') {
        saveAs(e.data.blob, e.data.fileName)
        toast.success('Download complete')
        get().cleanup(stageId)
      }

      if (e.data.type === 'error') {
        toast.error(e.data.message || 'Download failed')
        get().cleanup(stageId)
      }
    }

    worker.onerror = () => {
      toast.error('Download worker crashed')
      get().cleanup(stageId)
    }
  },

  cleanup: (stageId) => {
    const downloads = get().downloads
    const entry = downloads[stageId]

    entry?.worker?.terminate()

    const { [stageId]: _, ...rest } = downloads

    set({ downloads: rest })
  },

  //   cancel like AbortController
  cancelDownload: (stageId) => {
    const entry = get().downloads[stageId]
    if (!entry) return

    entry.worker?.terminate()

    toast.info('Download cancelled')

    const { [stageId]: _, ...rest } = get().downloads
    set({ downloads: rest })
  },
}))

export const usePlaceHolderDownloadStore = create((set, get) => ({
  rows: {},

  startDownload: ({ rowId, workerPayload }) => {
    const worker = new Worker(new URL('./workers/placeholderZipWorker', import.meta.url), {
      type: 'module',
    })

    const abortController = new AbortController()

    set((state) => ({
      rows: {
        ...state.rows,
        [rowId]: {
          isDownloading: true,
          progress: { pct: 0, meta: { loaded: 0, total: 0 } },
          worker,
          abortController,
        },
      },
    }))

    worker.postMessage(workerPayload)

    worker.onmessage = (e) => {
      const entry = get().rows[rowId]
      if (!entry) return

      if (e.data.type === 'progress') {
        return set((state) => ({
          rows: {
            ...state.rows,
            [rowId]: {
              ...entry,
              progress: { pct: e.data.pct, meta: e.data.meta },
            },
          },
        }))
      }

      if (e.data.type === 'done') {
        saveAs(e.data.blob, e.data.fileName)
        toast.success(`Download complete: ${e.data.fileName}`)
        worker.terminate()
        const copy = { ...get().rows }
        delete copy[rowId]
        return set({ rows: copy })
      }

      if (e.data.type === 'error') {
        toast.error(e.data.message || 'Download failed')
        console.error('Download failed', e.data.message)
        worker.terminate()
        const copy = { ...get().rows }
        delete copy[rowId]
        return set({ rows: copy })
      }
    }
  },

  cancelDownload: (rowId) => {
    const entry = get().rows[rowId]
    if (!entry) return

    try {
      entry.abortController?.abort()
      entry.worker?.postMessage({ type: 'abort' })
    } catch {}

    entry.worker?.terminate()

    set((state) => {
      const copy = { ...state.rows }
      delete copy[rowId]
      return { rows: copy }
    })
  },
}))
